// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/AiCredits_PegOverrideInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * AiCredits_PegOverrideInput — body for POST /ai/credits/peg-overrides.
 *
 * Sets the per-franchise peg (USD of provider cost per credit):
 *
 *     micro_credits = round( (provider_cost_usd / peg_usd) * 1_000_000 )
 *
 * so a SMALLER peg burns that franchise's credits FASTER. That is the lever;
 * the validation below is what stops it from becoming a foot-gun.
 *
 * Required:
 *   franquia_id (int)  — positive.
 *   peg_usd (string)   — DECIMAL STRING. See PEG RULES.
 * Optional:
 *   reason (string)    — staff note carried onto the row.
 *
 * PEG RULES — all four exist because of a specific failure mode:
 *
 *   > 0        a zero or negative peg divides the entire credit computation by
 *              zero. Rejected here, at the boundary, not downstream.
 *   <= MAX_DECIMALS (12)
 *              the column is decimal(18,12). A thirteenth place would be
 *              silently truncated by MySQL and the franchise would burn at a
 *              rate nobody typed.
 *   no exponent notation
 *              JavaScript's String(0.000000001) is '1e-9', and every peg below
 *              1e-6 formats that way. is_numeric() accepts it and (float) reads
 *              it correctly, so it would pass every naive check and then sit in
 *              the database as the string '1e-9' — displayed back to the
 *              operator as gibberish and impossible to compare textually. The
 *              front end must send plain decimal notation; this is the check
 *              that makes that contractual rather than hopeful.
 *   >= MIN_PEG_USD
 *              a peg of 1e-12 against a typical $0.0004 prompt burns ~400
 *              million credits in one call — a wallet-emptying typo. The floor
 *              is a sanity rail, not a business rule: it is three orders of
 *              magnitude below the smallest peg anyone has had a reason to set.
 */
import { registerContract } from './validate'

export interface AiCredits_PegOverrideInput {
franquia_id: number
peg_usd: string
reason?: string
}

registerContract('AiCredits_PegOverrideInput', {
  franquia_id: { type: 'number',  required: true },
  peg_usd:     { type: 'string',  required: true },
  reason:      { type: 'string',  required: false },
})
